export default __webpack_public_path__ + "static/media/CeloTax.c32e9399.jpeg";